/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import React, { useContext, useEffect, useState } from 'react';

import { GeneralContext } from '../../../core/app-context/GeneralContext';
import {
  buttonsSideBar,
  buttonsSideBarProfile,
} from '../../../core/route/menuRoutes.json';
import ButtonMenu from './components/ButtonMenu';
import { Container } from './styles';

function SideBar() {
  const { sideMenu, idMenuSelected } = useContext(GeneralContext);
  const [buttons, setButtons] = useState(buttonsSideBar);

  useEffect(() => {
    if (sideMenu === 'profile') {
      setButtons(buttonsSideBarProfile);
    } else {
      setButtons(buttonsSideBar);
    }
  }, [sideMenu]);

  return (
    <Container>
      {buttons.map((button) => {
        const { menu, id, label, path, icon } = button;

        if (menu) {
          if (idMenuSelected === id) {
            return (
              <ButtonMenu
                selected
                key={id}
                id={id}
                label={label}
                icon={icon}
                path={path}
              />
            );
          }
          return (
            <ButtonMenu
              id={id}
              key={id}
              label={label}
              icon={icon}
              path={path}
            />
          );
        }
      })}
    </Container>
  );
}

export default SideBar;
